/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './PortalContainer.module.less';

function PortalContainer(props: any) {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        props.hide();
      }
    };
    // To ensure the event listener is not invoked immediately upon component mounting,
    // a timer with a delay of 0 milliseconds is used. This effectively defers the
    // addition of the event listener until after the current call stack has cleared,
    // which includes the component's initial render process. This technique ensures
    // that the event listener for 'click' events on the document is added only after
    // the component has been fully rendered, thereby preventing any unintended
    // immediate invocation of the handleClickOutside function.
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside, false);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []); // Removed ref.current from dependency array to avoid re-adding the event listener on ref changes

  const portalRoot = document.getElementById('portal-root');
  if (!portalRoot) return null;

  return ReactDOM.createPortal(
    <div ref={ref} className={styles.portalContainer} style={props?.style}>
      {props.children}
    </div>,
    portalRoot
  );
}

export default PortalContainer;
